/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTariffProcedureParamsWorkplaceState } from './TariffProcedureParams';

type TariffProcedureParamAddButtonProps = {
    showModal: () => void;
};

const TariffProcedureParamAddButton = ({ showModal }: TariffProcedureParamAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useTariffProcedureParamsWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default TariffProcedureParamAddButton;
